// @flow
import React, { Component } from "react";
import classNames from "classnames";
import GridList from "@material-ui/core/GridList";
import GridListTile from "@material-ui/core/GridListTile";
import GridListTileBar from "@material-ui/core/GridListTileBar";
import CancelIcon from "@material-ui/icons/Cancel";
import { withStyles } from "@material-ui/core/styles";

import type { DictionaryType } from "../../../global/types/GeneralTypes";
import type { IconStylesClassesType } from "../../../global/styles/iconStyles";
import { iconStyles } from "../../../global/styles/iconStyles";
import PersonImage from "../../../../images/person_place.svg";

const styles = (theme: DictionaryType): DictionaryType => ({
  ...iconStyles(theme),
  gridRoot: {
    textAlign: "center",
    width: "100%",
    height: "100%",
    overflow: "hidden"
  },
  gridBlock: {
    width: "100% !IMPORTANT",
    height: "auto !IMPORTANT",
    position: "relative",
    "&:hover": {
      "& $closeBtn": {
        display: "block"
      }
    }
  },
  closeBtn: {
    position: "absolute",
    right: "-1px",
    top: "-1px",
    display: "none",
    cursor: "pointer"
  },
  gridImage: {
    width: "100%",
    height: "100%"
  },
  normalText: {
    whiteSpace: "normal"
  },
  leftMargin: {
    marginLeft: "5px"
  },
  thumbImage: {
    width: "96px",
    height: "96px",
    margin: "0 15px 15px 0",
    float: "left"
  },
  zoomInCursor: {
    cursor: "zoom-in"
  }
});

type DisplayFaceClassesType = {
  ...IconStylesClassesType,
  gridRoot: DictionaryType,
  gridBlock: DictionaryType,
  closeBtn: DictionaryType,
  gridImage: DictionaryType,
  normalText: DictionaryType,
  leftMargin: DictionaryType,
  thumbImage: DictionaryType,
  zoomInCursor: DictionaryType
};

type DisplayFacePropsType = {
  classes: DisplayFaceClassesType,
  img?: string,
  title?: string,
  subtitle?: string,
  onClick?: Function,
  cancelClick?: Function,
  isThumbNail?: boolean,
  isZoomin?: boolean
};

class DisplayFace extends Component<DisplayFacePropsType, *> {
  render(): * {
    const classes = this.props.classes;

    return (
      <div className={this.props.isThumbNail && classes.thumbImage}>
        <GridList className={classes.gridRoot}>
          <GridListTile
            className={classNames(
              this.props.isZoomin && classes.zoomInCursor,
              classes.gridBlock
            )}
          >
            <img
              src={this.props.img ? this.props.img : PersonImage}
              className={classes.gridImage}
              {...(this.props.onClick ? { onClick: this.props.onClick } : {})}
            />
            {this.props.title && (
              <GridListTileBar
                {...(this.props.title ? { title: this.props.title } : {})}
                {...(this.props.subtitle
                  ? { subtitle: this.props.subtitle }
                  : {})}
                classes={{
                  title: classes.normalText,
                  subtitle: classes.normalText,
                  titleWrap: classes.leftMargin
                }}
              />
            )}
            {this.props.cancelClick && (
              <CancelIcon
                className={classNames(classes.closeBtn, classes.greenIcon)}
                onClick={this.props.cancelClick}
              />
            )}
          </GridListTile>
        </GridList>
      </div>
    );
  }
}

export default withStyles(styles)(DisplayFace);
